import React, { useState, useEffect } from 'react';
import './../agent_page.css';
import { getServices, addService, updateService, deleteService, getServiceCategories, addServiceCategory, updateServiceCategory, deleteServiceCategory } from '../../../controller/agent_data_controller';

const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '25px',
                borderRadius: '8px',
                width: '500px',
                maxWidth: '90%',
                boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0 }}>{title}</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#666' }}>×</button>
                </div>
                {children}
            </div>
        </div>
    );
};

export const ManageServices = () => {
    const [services, setServices] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isEditingService, setIsEditingService] = useState(false);
    const [isEditingCategory, setIsEditingCategory] = useState(false);
    const [isManagingCategories, setIsManagingCategories] = useState(false);

    const [currentService, setCurrentService] = useState({ id: null, name: '', price: '', required_documents: [], category_id: '' });
    const [newService, setNewService] = useState({ name: '', price: '', required_documents: [], category_id: '' });

    const [newCategory, setNewCategory] = useState('');
    const [editingCategory, setEditingCategory] = useState({ id: null, name: '' });

    const [docInput, setDocInput] = useState('');
    const [editDocInput, setEditDocInput] = useState('');
    const [loading, setLoading] = useState(true);

    const fetchCategories = async () => {
        const data = await getServiceCategories();
        const formattedCategories = data.map(c => ({ id: c[0], name: c[1] }));
        setCategories(formattedCategories);
    };

    const fetchServices = async () => {
        setLoading(true);
        const data = await getServices();
        const formattedServices = data.map(s => {
            let docs = [];
            try {
                docs = JSON.parse(s[3]);
            } catch (e) {
                docs = s[3] ? s[3].split(',').map(d => d.trim()).filter(d => d !== '') : [];
            }
            return {
                id: s[0],
                name: s[1],
                price: s[2],
                required_documents: docs,
                category_name: s[4] || 'Uncategorized',
                category_id: s[5]
            };
        });
        setServices(formattedServices);
        setLoading(false);
    };

    useEffect(() => {
        fetchServices();
        fetchCategories();
    }, []);

    const handleAddDoc = (isEdit = false) => {
        const input = isEdit ? editDocInput : docInput;
        if (input.trim()) {
            if (isEdit) {
                setCurrentService({
                    ...currentService,
                    required_documents: [...currentService.required_documents, input.trim()]
                });
                setEditDocInput('');
            } else {
                setNewService({
                    ...newService,
                    required_documents: [...newService.required_documents, input.trim()]
                });
                setDocInput('');
            }
        }
    };

    const handleRemoveDoc = (index, isEdit = false) => {
        if (isEdit) {
            setCurrentService({
                ...currentService,
                required_documents: currentService.required_documents.filter((_, i) => i !== index)
            });
        } else {
            setNewService({
                ...newService,
                required_documents: newService.required_documents.filter((_, i) => i !== index)
            });
        }
    };

    const handleAdd = async () => {
        if (newService.name && newService.price) {
            const result = await addService(newService.name, newService.price, JSON.stringify(newService.required_documents), newService.category_id);
            if (result === 'success') {
                setNewService({ name: '', price: '', required_documents: [], category_id: '' });
                setDocInput('');
                fetchServices();
            } else {
                alert('Failed to add service');
            }
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this service?')) {
            const result = await deleteService(id);
            if (result === 'success') {
                fetchServices();
            } else {
                alert('Failed to delete service');
            }
        }
    };

    const handleEdit = (service) => {
        setCurrentService(service);
        setIsEditingService(true);
    };

    const handleUpdate = async () => {
        const result = await updateService(currentService.id, currentService.name, currentService.price, JSON.stringify(currentService.required_documents), currentService.category_id);
        if (result === 'success') {
            setIsEditingService(false);
            fetchServices();
        } else {
            alert('Failed to update service');
        }
    };

    const handleAddCategory = async () => {
        if (newCategory.trim()) {
            const result = await addServiceCategory(newCategory.trim());
            if (result === 'success') {
                setNewCategory('');
                fetchCategories();
            } else {
                alert('Failed to add category');
            }
        }
    };

    const handleDeleteCategory = async (id) => {
        if (window.confirm('Are you sure you want to delete this category? Services in this category will become uncategorized.')) {
            const result = await deleteServiceCategory(id);
            if (result === 'success') {
                fetchCategories();
                fetchServices();
            } else {
                alert('Failed to delete category');
            }
        }
    };

    const handleUpdateCategory = async () => {
        if (editingCategory.name.trim()) {
            const result = await updateServiceCategory(editingCategory.id, editingCategory.name.trim());
            if (result === 'success') {
                setIsEditingCategory(false);
                fetchCategories();
                fetchServices();
            } else {
                alert('Failed to update category');
            }
        }
    };

    if (loading) return <div style={{ padding: '20px' }}>Loading services...</div>;

    return (
        <div style={{ padding: '20px', backgroundColor: 'rgba(246, 246, 249, 1)', minHeight: '100vh' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 className="services-title" style={{ margin: 0 }}>Manage Services</h2>
                <button
                    onClick={() => setIsManagingCategories(!isManagingCategories)}
                    style={{ padding: '10px 20px', backgroundColor: isManagingCategories ? '#9e9e9e' : '#673ab7', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', transition: '0.3s' }}
                >
                    {isManagingCategories ? 'Back to Services' : 'Manage Categories'}
                </button>
            </div>

            {isManagingCategories ? (
                <div className="content-div-demo" style={{ padding: '25px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                    <h3 style={{ borderBottom: '2px solid #673ab7', paddingBottom: '10px', display: 'inline-block' }}>Add Service Category</h3>
                    <div style={{ display: 'flex', gap: '10px', margin: '20px 0' }}>
                        <input
                            type="text"
                            placeholder="Category Name (e.g. Income Tax, GST)"
                            value={newCategory}
                            onChange={(e) => setNewCategory(e.target.value)}
                            style={{ padding: '12px', borderRadius: '6px', border: '1px solid #ddd', flex: 1, fontSize: '14px' }}
                        />
                        <button onClick={handleAddCategory} style={{ padding: '10px 25px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>Add Category</button>
                    </div>

                    <div style={{ marginTop: '30px' }}>
                        <div style={{ display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '6px 6px 0 0', borderBottom: '1px solid #dee2e6' }}>
                            <div style={{ flex: 3 }}>Category Name</div>
                            <div style={{ flex: 1, textAlign: 'center' }}>Actions</div>
                        </div>
                        {categories.length === 0 ? (
                            <div style={{ padding: '30px', textAlign: 'center', color: '#888', fontStyle: 'italic', border: '1px solid #eee', borderTop: 'none' }}>No categories created yet.</div>
                        ) : (
                            categories.map(cat => (
                                <div key={cat.id} style={{ display: 'flex', padding: '15px 12px', borderBottom: '1px solid #eee', alignItems: 'center' }}>
                                    <div style={{ flex: 3, fontSize: '15px' }}>{cat.name}</div>
                                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                        <button onClick={() => { setEditingCategory(cat); setIsEditingCategory(true); }} style={{ color: '#2196F3', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '500' }}>Edit</button>
                                        <button onClick={() => handleDeleteCategory(cat.id)} style={{ color: '#f44336', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '500' }}>Delete</button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            ) : (
                <>
                    <div className="content-div-demo" style={{ padding: '25px', marginBottom: '25px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                        <h3 style={{ borderBottom: '2px solid #2196F3', paddingBottom: '10px', display: 'inline-block' }}>Add New Service</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '15px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 2 }}>
                                    <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '5px' }}>Service Name</label>
                                    <input
                                        type="text"
                                        placeholder="e.g. GST Registration"
                                        value={newService.name}
                                        onChange={(e) => setNewService({ ...newService, name: e.target.value })}
                                        style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}
                                    />
                                </div>
                                <div style={{ flex: 1.5 }}>
                                    <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '5px' }}>Category</label>
                                    <select
                                        value={newService.category_id || ''}
                                        onChange={(e) => setNewService({ ...newService, category_id: e.target.value })}
                                        style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', width: '100%', cursor: 'pointer' }}
                                    >
                                        <option value="">Select Category</option>
                                        {categories.map(cat => (
                                            <option key={cat.id} value={cat.id}>{cat.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div style={{ width: '120px' }}>
                                    <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '5px' }}>Price (₹)</label>
                                    <input
                                        type="number"
                                        placeholder="0"
                                        value={newService.price}
                                        onChange={(e) => setNewService({ ...newService, price: e.target.value })}
                                        style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}
                                    />
                                </div>
                            </div>

                            <div>
                                <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '8px' }}>Required Documents</label>
                                <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                    <input
                                        type="text"
                                        placeholder="Add required document one by one..."
                                        value={docInput}
                                        onChange={(e) => setDocInput(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && handleAddDoc(false)}
                                        style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', flex: 1 }}
                                    />
                                    <button onClick={() => handleAddDoc(false)} style={{ padding: '10px 20px', backgroundColor: '#e8eaf6', color: '#3f51b5', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>+ Add</button>
                                </div>

                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', minHeight: '40px', padding: '10px', backgroundColor: '#fafafa', borderRadius: '6px', border: '1px dashed #ccc' }}>
                                    {newService.required_documents.map((doc, index) => (
                                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '5px 12px', backgroundColor: '#fff', borderRadius: '20px', fontSize: '0.85em', border: '1px solid #e0e0e0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                                            <span>{doc}</span>
                                            <span onClick={() => handleRemoveDoc(index, false)} style={{ cursor: 'pointer', color: '#f44336', fontWeight: 'bold', fontSize: '16px' }}>×</span>
                                        </div>
                                    ))}
                                    {newService.required_documents.length === 0 &&
                                        <span style={{ color: '#aaa', fontStyle: 'italic', fontSize: '13px', alignSelf: 'center' }}>No documents added yet. Addition is optional.</span>
                                    }
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                <button onClick={handleAdd} style={{ padding: '12px 35px', backgroundColor: '#2196F3', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '15px' }}>Create Service</button>
                            </div>
                        </div>
                    </div>

                    <div className="content-div-demo" style={{ padding: '25px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                        <div style={{ display: 'flex', fontWeight: 'bold', padding: '15px 0', borderBottom: '2px solid #eee', marginBottom: '10px', color: '#555', fontSize: '14px' }}>
                            <div style={{ flex: 1.5 }}>Service Name</div>
                            <div style={{ flex: 1 }}>Category</div>
                            <div style={{ flex: 0.8 }}>Price (₹)</div>
                            <div style={{ flex: 1.5 }}>Required Documents</div>
                            <div style={{ flex: 1, textAlign: 'center' }}>Actions</div>
                        </div>
                        {services.length === 0 ? (
                            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>No services available.</div>
                        ) : (
                            services.map((service) => (
                                <div key={service.id} style={{ display: 'flex', padding: '18px 0', borderBottom: '1px solid #f1f1f1', alignItems: 'center', fontSize: '14px' }}>
                                    <div style={{ flex: 1.5, fontWeight: '500' }}>{service.name}</div>
                                    <div style={{ flex: 1 }}>
                                        <span style={{ padding: '3px 10px', backgroundColor: '#e3f2fd', color: '#1976d2', borderRadius: '15px', fontSize: '0.75em', fontWeight: 'bold', border: '1px solid #bbdefb' }}>
                                            {service.category_name}
                                        </span>
                                    </div>
                                    <div style={{ flex: 0.8 }}>₹{service.price}</div>
                                    <div style={{ flex: 1.5, display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        {service.required_documents.length > 0 ? (
                                            service.required_documents.slice(0, 3).map((doc, idx) => (
                                                <span key={idx} style={{ padding: '2px 8px', backgroundColor: '#f5f5f5', borderRadius: '4px', fontSize: '0.75em', color: '#666' }}>{doc}</span>
                                            ))
                                        ) : (
                                            <span style={{ color: '#ccc', fontSize: '0.75em' }}>None</span>
                                        )}
                                        {service.required_documents.length > 3 && <span style={{ fontSize: '0.75em', color: '#999' }}>+{service.required_documents.length - 3} more</span>}
                                    </div>
                                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                        <button onClick={() => handleEdit(service)} style={{ background: 'none', border: 'none', color: '#2196F3', cursor: 'pointer', fontWeight: '500' }}>Edit</button>
                                        <button onClick={() => handleDelete(service.id)} style={{ background: 'none', border: 'none', color: '#f44336', cursor: 'pointer', fontWeight: '500' }}>Delete</button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </>
            )}

            <Modal isOpen={isEditingService} onClose={() => setIsEditingService(false)} title="Edit Service">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div>
                        <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '5px' }}>Service Name</label>
                        <input
                            type="text"
                            value={currentService.name}
                            onChange={(e) => setCurrentService({ ...currentService, name: e.target.value })}
                            style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '15px' }}>
                        <div style={{ flex: 2 }}>
                            <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '5px' }}>Category</label>
                            <select
                                value={currentService.category_id || ''}
                                onChange={(e) => setCurrentService({ ...currentService, category_id: e.target.value })}
                                style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', width: '100%', cursor: 'pointer' }}
                            >
                                <option value="">Select Category</option>
                                {categories.map(cat => (
                                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                                ))}
                            </select>
                        </div>
                        <div style={{ flex: 1 }}>
                            <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '5px' }}>Price (₹)</label>
                            <input
                                type="number"
                                value={currentService.price}
                                onChange={(e) => setCurrentService({ ...currentService, price: e.target.value })}
                                style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}
                            />
                        </div>
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '8px' }}>Required Documents</label>
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                            <input
                                type="text"
                                placeholder="Add document..."
                                value={editDocInput}
                                onChange={(e) => setEditDocInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleAddDoc(true)}
                                style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ddd', flex: 1 }}
                            />
                            <button onClick={() => handleAddDoc(true)} style={{ padding: '10px 15px', backgroundColor: '#e3f2fd', color: '#1976d2', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Add</button>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '6px', border: '1px solid #eee' }}>
                            {currentService.required_documents.map((doc, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '4px 10px', backgroundColor: '#fff', borderRadius: '15px', fontSize: '0.8em', border: '1px solid #ddd' }}>
                                    <span>{doc}</span>
                                    <span onClick={() => handleRemoveDoc(index, true)} style={{ cursor: 'pointer', color: '#f44336', fontWeight: 'bold' }}>×</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '10px' }}>
                        <button onClick={() => setIsEditingService(false)} style={{ padding: '10px 20px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: '#fff', cursor: 'pointer' }}>Cancel</button>
                        <button onClick={handleUpdate} style={{ padding: '10px 25px', borderRadius: '6px', border: 'none', backgroundColor: '#4CAF50', color: 'white', cursor: 'pointer', fontWeight: 'bold' }}>Update Service</button>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={isEditingCategory} onClose={() => setIsEditingCategory(false)} title="Edit Category">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div>
                        <label style={{ display: 'block', fontSize: '13px', color: '#666', marginBottom: '5px' }}>Category Name</label>
                        <input
                            type="text"
                            value={editingCategory.name}
                            onChange={(e) => setEditingCategory({ ...editingCategory, name: e.target.value })}
                            style={{ padding: '12px', borderRadius: '6px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '10px' }}>
                        <button onClick={() => setIsEditingCategory(false)} style={{ padding: '10px 20px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: '#fff', cursor: 'pointer' }}>Cancel</button>
                        <button onClick={handleUpdateCategory} style={{ padding: '10px 25px', borderRadius: '6px', border: 'none', backgroundColor: '#2196F3', color: 'white', cursor: 'pointer', fontWeight: 'bold' }}>Save Changes</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
